import { css } from '@emotion/react'
import { Cell, Grid } from 'bold-ui'
import { CheckboxField, DateField, MonthField } from 'components/form'
import { RastreioCancerPerguntaOpcaoEnum } from 'graphql/types.generated'
import { useAtendimentoContext } from 'hooks/atendimento-context/useAtendimentoContext'
import { useField } from 'react-final-form'

import { ExamePreventivoRadioField } from './ExamePreventivoRadioField'
import { CitopatologicoPerguntaField } from './model-citopatologico'
import { MotivoExameRadioField } from './MotivoExameRadioField'
import { SangramentoMenopausaRadioField } from './SangramentoMenopausaRadioField'
import { SangramentoRelacaoSexualRadioField } from './SangramentoRelacaoSexualRadioField'
import { SimNaoNaoSabeRadioField } from './SimNaoNaoSabeRadioField'
import { SituacaoEspecialRadioField } from './SituacaoEspecialRadioField'

const IDADE_MAXIMA = 64
const IDADE_MINIMA = 25

export function CitopatologicoAnamneseModalStep() {
  const { cidadao } = useAtendimentoContext()
  const idade = cidadao.idadeEmAnos
  const showSituacaoEspecial = idade < IDADE_MINIMA || idade > IDADE_MAXIMA
  const showNuncaFezPreventivo = idade > IDADE_MAXIMA

  const {
    input: { value: examePreventivo },
  } = useField<RastreioCancerPerguntaOpcaoEnum>(CitopatologicoPerguntaField.examePreventivo, {
    subscription: { value: true },
  })

  const {
    input: { value: checkDum },
  } = useField<RastreioCancerPerguntaOpcaoEnum>('checkDum', {
    subscription: { value: true },
  })

  const showDataPreventivo = examePreventivo === RastreioCancerPerguntaOpcaoEnum.SIM_PAPANICOLAU

  const { positionCheckbox } = createStyles()
  return (
    <Grid>
      <Cell size={12}>
        <MotivoExameRadioField name={CitopatologicoPerguntaField.motivoExame} required />
      </Cell>
      {showSituacaoEspecial && (
        <Cell size={12}>
          <SituacaoEspecialRadioField
            name={CitopatologicoPerguntaField.situacaoEspecial}
            showNuncaFezPreventivo={showNuncaFezPreventivo}
          />
        </Cell>
      )}
      <Cell size={12}>
        <ExamePreventivoRadioField name={CitopatologicoPerguntaField.examePreventivo} required />
      </Cell>
      {showDataPreventivo && (
        <Cell size={7}>
          <MonthField
            name={CitopatologicoPerguntaField.dataPreventivo}
            label='Ano em que realizou o ultimo preventivo'
            required
          />
        </Cell>
      )}
      <Cell size={12}>
        <SimNaoNaoSabeRadioField name={CitopatologicoPerguntaField.diu} label='Usa DIU?' />
      </Cell>
      <Cell size={12}>
        <SimNaoNaoSabeRadioField name={CitopatologicoPerguntaField.estaGravida} label='Está gravida?' />
      </Cell>
      <Cell size={12}>
        <SimNaoNaoSabeRadioField
          name={CitopatologicoPerguntaField.usaPilulaAnticoncepcional}
          label='Usa pílula anticoncepcional?'
          required
        />
      </Cell>
      <Cell size={12}>
        <SimNaoNaoSabeRadioField
          name={CitopatologicoPerguntaField.usaHormonio}
          label='Usa hormônio/remédio para tratar a menopausa?'
          required
        />
      </Cell>
      <Cell size={12}>
        <SimNaoNaoSabeRadioField
          name={CitopatologicoPerguntaField.radioterapia}
          label='Fez tratamento de radioterapia?'
        />
      </Cell>

      <Cell size={6}>
        <DateField name={CitopatologicoPerguntaField.dum} label='Data da última menstruação' required={!checkDum} />
      </Cell>
      <Cell size={6} style={positionCheckbox}>
        <CheckboxField name='checkDum' label='Não lembra/não sabe' />
      </Cell>

      <Cell size={12}>
        <SangramentoRelacaoSexualRadioField name={CitopatologicoPerguntaField.sangramentoPosRelacao} required />
      </Cell>
      <Cell size={12}>
        <SangramentoMenopausaRadioField name={CitopatologicoPerguntaField.sangramentoPosMenopausa} />
      </Cell>
    </Grid>
  )
}

const createStyles = () => ({
  positionCheckbox: css`
    padding-top: 2.5rem;
    align-self: flex-start;
  `,
})
